import { render, staticRenderFns } from "./task.vue?vue&type=template&id=5b3f0589&"
import script from "./task.vue?vue&type=script&lang=js&"
export * from "./task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wd\\fin24\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b3f0589')) {
      api.createRecord('5b3f0589', component.options)
    } else {
      api.reload('5b3f0589', component.options)
    }
    module.hot.accept("./task.vue?vue&type=template&id=5b3f0589&", function () {
      api.rerender('5b3f0589', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/task.vue"
export default component.exports